import { createFileRoute, useSearch } from "@tanstack/react-router";
import { TemplateEditorContainer } from "../../../features/templates/containers/template-editor-container";

export const Route = createFileRoute("/app/template/new")({
  validateSearch: (search: Record<string, unknown>) => {
    return { from: typeof search.from === "string" ? search.from : undefined };
  },
  component: () => <NewTemplatePage />,
});

function NewTemplatePage() {
  const { from } = useSearch({ from: "/app/template/new" });
  return <TemplateEditorContainer mode="create" fromTemplateId={from} />;
}
